import { createContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  signInWithGooglePopup,
  auth,
} from "../components/auth/FirebaseGoogleAuth";
import GoogleLogin from "../components/auth/GoogleLogin";

export const SignInContext = createContext();

export const SignInProvider = ({ children }) => {
  const navigate = useNavigate();
  const allowedDomains = ["interactiveworkshops.com","cegos.uk","cegos.co.uk"];

  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAuthenticating, setIsAuthenticating] = useState(false);
  const [userPhoto, setUserPhoto] = useState(null);

  const logOutGoogleUser = useCallback(async () => {
    try {
      await auth.signOut();
      console.log("User signed out");
      setUser(null);

      navigate("/");
    } catch (error) {
      console.error("Error during sign-out:", error);
    }
  }, [navigate]);

  const logGoogleUser = useCallback(async () => {
    if (isAuthenticating) return;
    setIsAuthenticating(true);
    try {
      const response = await signInWithGooglePopup();
      const userEmail = response.user.email;
      const emailDomain = userEmail.substring(userEmail.lastIndexOf("@") + 1);

      if (!allowedDomains.includes(emailDomain)) {
        console.error("Unauthorized email domain:", emailDomain);
        logOutGoogleUser();
        setUser(null);
        alert("Your email domain is not allowed to sign in.");

        return;
      }
      setUserPhoto(`${response.user.photoURL}?t=${Date.now()}`);

     // setUserPhoto(response.user.photoURL);
      //console.log("User signed in:", response);
      setUser(response.user);
      navigate("/home");
      console.log("User signed in:", response.user);
    } catch (error) {
      console.error("Error during sign-in:", error);
    } finally {
      setIsAuthenticating(false);
    }
  }, [logOutGoogleUser, navigate, isAuthenticating]);

  useEffect(() => {
    let componentMounted = true;

    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (!componentMounted) return;
      if (user) {
        const emailDomain = user.email.substring(
          user.email.lastIndexOf("@") + 1
        );
        if (!allowedDomains.includes(emailDomain)) {
          logOutGoogleUser();
          return;
        }
        setUser(user);
        setUserPhoto(`${user.photoURL}?t=${Date.now()}`);
      } else {
        setUser(null);
       setUserPhoto(null);
        navigate("/");
      }
      setLoading(false);
    });

    return () => {
      componentMounted = false;
      unsubscribe();
    };
  }, [navigate, logOutGoogleUser]);

  if (loading) {
    return null;
  }

  return (
    <SignInContext.Provider value={{ logGoogleUser, user, logOutGoogleUser,userPhoto }}>
      {children}
    </SignInContext.Provider>
  );
};
